module.exports = __webpack_public_path__ + "media/images/prando-shop-f6fd211c3e78702f1f50e88f90fb17b4.jpg";